<template>
  <base-page-teaching-feed mode="instructor" :disabled="disabled" />
</template>

<script>
import { feedMixin } from '@/mixins/feedMixin';
import BasePageTeachingFeed from './BasePageTeachingFeed';

export default {
  components: {
    BasePageTeachingFeed
  },

  mixins: [feedMixin],

  computed: {
    disabled() {
      return this.$_feedMixin_learningUnit
        ? !this.$_feedMixin_learningUnit.isOwner(this.$currentUser.id) ||
            (this.$_feedMixin_learningUnit.required_review &&
              !this.$_feedMixin_learningUnit.is_published)
        : false;
    }
  }
};
</script>
